import dayjs from 'dayjs';

import {
  ChartTooltipElementProps,
  DataPopperRow,
  Typography,
  tokens,
} from '@cast/design-system';

import { useCostReportContext } from 'features/cost-report/hooks/useCostReportContext';

type TooltipData = { timestamp: string; forecast?: boolean };

export const usePodCountTooltip = () => {
  const { timezone } = useCostReportContext();

  const tooltipHeader = ({
    data,
    testId,
  }: ChartTooltipElementProps<TooltipData>) => (
    <DataPopperRow
      testId={testId}
      left={
        <Typography variant="L10M" color={tokens.theme.fg.structural.secondary}>
          {dayjs.utc(data.timestamp).tz(timezone).format('MMM D')}
        </Typography>
      }
      right={
        data.forecast ? (
          <Typography
            variant="L10M"
            color={tokens.theme.fg.structural.secondary}
          >
            Forecast
          </Typography>
        ) : undefined
      }
    />
  );

  return { tooltipHeader };
};
